import React, { useEffect, useState } from "react";
import {
  callNonStoreApi,
  handleImageUpload,
  isNullOrUndefined,
} from "../utils/utils";
import {
  AddFlex,
  CustomInput,
  CustomInputLabel,
  CustomText,
  Gap,
  InputLabel,
  PrimaryActionButton,
} from "./reusableStyles";
import ImageUploadComponent from "./ImageUploadComponent";
import {
  CreateSubdomainClient,
  UpdateSubdomainClient,
} from "../utils/ApiEndpoints";
import { enqueueSnackbar } from "notistack";
import { CircularProgress } from "@mui/material";
import { IOSSwitch } from "./CustomSwitch";

function ClientDetailsDrawer({ clientDetails, clientId, setForceRefresh }) {
  const [logoFile, setLogoFile] = useState(null);
  const [smallLogoFile, setSmallLogoFile] = useState(null);
  const [data, setData] = useState({
    name: "",
    logo: "",
    small_logo: "",
    domain: "",
    sub_text: "",
    couponDetails: {
      name: "",
      value: "",
      isActive: Boolean,
    },
  });
  const [loading, setLoading] = useState(false);
  const handleSetCouponDetails = (key, value) => {
    setData((prev) => {
      return {
        ...prev,
        couponDetails: {
          ...prev.couponDetails,
          [key]: value,
        },
      };
    });
  };
  const handleSetData = (key, value) => {
    setData((prev) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };
  const handleGetLogoFile = (file, url) => {
    setLogoFile(file);
    handleSetData("logo", url);
  };
  const handleGetSmallLogoFile = (file, url) => {
    setSmallLogoFile(file);
    handleSetData("small_logo", url);
  };
  useEffect(() => {
    if (!isNullOrUndefined(clientDetails)) {
      setData(clientDetails);
    }
  }, []);

  const handleUpdateCreate = async () => {
    try {
      const body = { ...data };
      const isEdit = !isNullOrUndefined(clientDetails);
      const endpoint = isEdit ? UpdateSubdomainClient : CreateSubdomainClient;
      if (!isNullOrUndefined(logoFile)) {
        body.logo = await handleImageUpload(logoFile, data.name);
      }
      if (!isNullOrUndefined(smallLogoFile)) {
        body.small_logo = await handleImageUpload(smallLogoFile, data.name);
      }
      setLoading(true);
      const response = await callNonStoreApi(
        endpoint,
        isEdit ? { data: body, clientId } : body
      );
      setForceRefresh((prev) => !prev);
      enqueueSnackbar("Success", {
        variant: "success",
      });
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Something went wrong, action failed. Check console", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AddFlex
      height="100%"
      flexDirection="column"
      gap="20px"
      style={{ padding: "20px" }}
    >
      <CustomInput
        label={"Client Name"}
        value={data.name}
        placeholder={"Eg: Bliss Arte"}
        onChange={(name) => handleSetData("name", name)}
      />
      <div></div>
      <CustomInput
        label={"Small text"}
        value={data.sub_text}
        placeholder={"Eg: A community for art enthusiasts"}
        onChange={(sub_text) => handleSetData("sub_text", sub_text)}
      />
      <div></div>

      <CustomInput
        label={"Client Domain"}
        value={data.domain}
        placeholder={"blissarte.growezy.in"}
        onChange={(domain) => handleSetData("domain", domain)}
      />
      <div></div>

      <div>
        <CustomInputLabel>Logo</CustomInputLabel>
        <ImageUploadComponent
          tempURL={data.logo}
          handleGetFile={handleGetLogoFile}
        />
        <CustomText margin="5px 0 0 0" fontSize="12px">
          Image dimensions should be 1080x1080
        </CustomText>
      </div>
      <div>
        <CustomInputLabel>Small Logo</CustomInputLabel>
        <ImageUploadComponent
          tempURL={data.small_logo}
          handleGetFile={handleGetSmallLogoFile}
        />
        <CustomText margin="5px 0 0 0" fontSize="12px">
          Image dimensions should be 1080x1080
        </CustomText>
      </div>
      <AddFlex gap="12px" flexDirection="column">
        <InputLabel style={{ margin: "0px" }}>Coupon Details</InputLabel>
        <AddFlex gap="12px">
          <CustomInput
            value={data.couponDetails?.name}
            onChange={(text) => {
              handleSetCouponDetails("name", text);
            }}
            placeholder={"WELCOME50"}
          />
          <CustomInput
            value={data.couponDetails?.value}
            type={"number"}
            onChange={(text) => {
              if (text > 100) {
                return;
              }
              handleSetCouponDetails("value", text);
            }}
            placeholder={"50"}
          />
        </AddFlex>
        <AddFlex gap="12px">
          <CustomText fontSize="14px" color="black">
            Is Coupon Active
          </CustomText>
          <IOSSwitch
            checked={data.couponDetails?.isActive}
            onChange={(e) => {
              handleSetCouponDetails("isActive", e.target.checked);
            }}
          />
        </AddFlex>
      </AddFlex>
      <Gap />
      <PrimaryActionButton onClick={handleUpdateCreate}>
        {loading ? (
          <CircularProgress sx={{ color: "white" }} size={14} />
        ) : isNullOrUndefined(clientDetails) ? (
          "Create"
        ) : (
          "Update"
        )}
      </PrimaryActionButton>
    </AddFlex>
  );
}

export default ClientDetailsDrawer;
